import React, { useState } from "react";
import {
    Button, Dialog, DialogActions, DialogContent, DialogTitle, FormControl, InputLabel, MenuItem,
    TableRow, Table,
    TableHead,
    TableBody,
    TableCell, Checkbox,
    FormControlLabel,
} from "@material-ui/core";
import AddIcon from '@material-ui/icons/Add';
import LanguageIcon from '@material-ui/icons/Language';

import ExportExcel from "../../Excelexport";
import { Card, Box } from "@material-ui/core";
import ActivityService from "./Locality/Service/activityService";
import ActivityTabelService from "./Locality/Service/activityTabelService";
import SubActivityService from "./Locality/Service/subActivityService";
import StudentService from "./Locality/Service/studentService"
import SuperActivityService from "./Locality/Service/superActivityService"
import * as Yup from 'yup';
import { Grid, Select, TextField } from "@material-ui/core";
import { useFormik } from 'formik';
import { useEffect } from 'react';
import DeleteIcon from '@material-ui/icons/Delete';
import RefreshIcon from '@material-ui/icons/Refresh';
import EditIcon from '@material-ui/icons/Edit';
import TablePagination from '@material-ui/core/TablePagination';
import Widget from "../../components/Widget/Widget";
import PageTitle from "../../components/PageTitle/PageTitle";
import SchoolDatePicker from "../../components/SchoolDatePicker/SchoolDatePicker";
import { withStyles, makeStyles } from '@material-ui/core/styles';
import AddClassService from "./Locality/Service/addClassService";
import TreeView from "@material-ui/lab/TreeView";
import TreeItem from "@material-ui/lab/TreeItem";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import ChevronRightIcon from "@material-ui/icons/ChevronRight";
const StyledTableCell = withStyles((theme) => ({
    head: {
        backgroundColor: "#0f3b62ad",
        color: theme.palette.common.white,
    },
    body: {
        fontSize: 14,
    },
}))(TableCell);
const useStyles = makeStyles((theme) => ({
    container: {
        display: 'flex',
        flexWrap: 'wrap',
    },
    textField: {
        marginLeft: theme.spacing(1),
        marginRight: theme.spacing(1),
        width: 200,
    },
}));
export default function ActivityExpected() {
    const tableHeaders = ['Class', 'Area Of Work', ' Activities', 'Exercises', 'Remarks',
        'Start Date', 'End Date', 'Edit', 'Delete', 'Add More'];
    //const tableHeaders = ['Class', 'Student Name', 'Area Of Work', 'List Of Activities', 'Exercise', 'Edit', 'Delete', 'Add More'];
    const classes = useStyles();
    const [activityList, setActivityList] = useState([]);
    const [studentList, setStudentList] = useState([]);
    const [subActivityList, setSubActivityList] = useState([]);
    const [classNameList, setClassNameList] = useState([]);
    const [age, setAge] = React.useState('');
    var [error, setError] = useState(null);
    const [activityIdList, setActivityIdList] = useState([]);
    const [open, setOpen] = React.useState(false);
  const [selectedActivities, setSelectedActivities] = useState([]);

    const [isFirstLoad, setIsFirstLoad] = React.useState(true);
    const [addClassList, setAddClassList] = useState([]);
    const [startDate, setStartDate] = useState('');
    const [result, setResult] = useState([]);
    const [endDate, setEndDate] = useState('');
    var [studentId, setStudentId] = useState("");

    const [addActivityList, setAddActivityList] = useState([]);
    const [addSuperActivityList, setAddSuperActivityList] = useState([]);
    const today = new Date();
    var [classId, setClassId] = useState("");
   

    const getWeekStartEnd = (date = new Date()) => {
        const current = new Date(date);
        const nextWeek = new Date(current);
        nextWeek.setDate(current.getDate() + 7);

        const formatDate = (d) => {
            const year = d.getFullYear();
            const month = String(d.getMonth() + 1).padStart(2, '0');
            const day = String(d.getDate()).padStart(2, '0');
            return `${year}-${month}-${day}`;
        };

        return {
            start: formatDate(current),
            end: formatDate(nextWeek),
        };
    };

    // const getWeekStartEnd = (date) => {
    //     const startOfWeek = new Date(date);
    //     startOfWeek.setDate(startOfWeek.getDate() - startOfWeek.getDay());
    //     const endOfWeek = new Date(date);
    //     endOfWeek.setDate(endOfWeek.getDate() + (5 - endOfWeek.getDay()));

    //     let startDay = startOfWeek.getDate();
    //     let startMonth = startOfWeek.getMonth() + 1;
    //     let startYear = startOfWeek.getFullYear();
    //     if (startDay < 10) {
    //         startDay = '0' + startDay;
    //     }

    //     if (startMonth < 10) {
    //         startMonth = `0${startMonth}`;
    //     }
    //     let format = startYear + "-" + startMonth + "-" + startDay;

    //     let endDay = endOfWeek.getDate();
    //     let endMonth = endOfWeek.getMonth() + 1;
    //     let endYear = endOfWeek.getFullYear();
    //     if (endDay < 10) {
    //         endDay = '0' + endDay;
    //     }

    //     if (endMonth < 10) {
    //         endMonth = `0${endMonth}`;
    //     }

    //     let format1 = endYear + "-" + endMonth + "-" + endDay;

    //     return { start: format, end: format1 };
    // }
    const date = new Date();
    const week = getWeekStartEnd(date);
    const [pg, setpg] = React.useState(0);
    const [rpg, setrpg] = React.useState(1000);
    const year = today.getFullYear();
    //   const today = dayjs();
    const [activity, setActivity] = useState({
        classId: '',
        sfd: '',
        // studentId:'',
        studentId: [],
        superActivityId: '',
        activityId: '',
        subActivityId: '',
        remarks: '',
        isEdit: false,
        endDate: '',


    });
    const handleChangePage = (event, newpage) => {
        setpg(newpage);
    }

    const handleChangeRowsPerPage = (event) => {
        setrpg(parseInt(event.target.value, 10));
        setpg(0);
    }
    
    const validationSchema = Yup.object().shape({
        // classId: Yup.string().required('Class Name is required'),
        studentId: Yup.array(),
        activityId: Yup.string(),
        subActivityId: Yup.string(),
        // academicYear:Yup.string(),
        remarks: Yup.string(),
        planning: Yup.string(),
        sfd: Yup.string().required('date is required'),
        endDate: Yup.string().required('date is required'),
        date: Yup.string().nullable(),
        isEdit: Yup.boolean(),
    });
    const verifyeetnt = () => {
        console.log(formik)
    }
    useEffect(() => {
        // getActivityList();
        getAddClassList();
        // getStudentActivityList();
        // getStudentList()
        // getSuperActivityList();
        // setStartDate(week.start);
        // setEndDate(week.end);

        onSubmit(isFirstLoad);
        return () => {
            setSubActivityList([]);
            setActivityIdList([]);
            setActivityList([]);
            setAddClassList([]);
            setStudentList([]);
            setAddSuperActivityList([]);
            // setClassNameList([]);
        }
    }, []);

    const getSuperActivityList = (event, obj) => {
        const userDetails = JSON.parse(localStorage.getItem("userDetail"));
        const getsupActList = { classId: event.target.value };

        SuperActivityService.getAllSuperActivityById(userDetails.schooleId, getsupActList).then((res) => {

            setAddSuperActivityList(res);
        }).catch((err) => {
            // setError(err.message);
        });
    }
    const getAllSuperActivityTabelMultiple = (event, obj) => {
        const userDetails = JSON.parse(localStorage.getItem("userDetail"));
        const getsupActList = { classId: event.target.value };

        SuperActivityService.getAllSuperActivityTabelMultiple( getsupActList).then((res) => {
            
            setSelectedActivities(res);
        }).catch((err) => {
            // setError(err.message);
        });
    }
    const handleOpen = (status) => {
        if (status) {
            // Reset all form values for new activity
            setActivity({
                classId: '',
                sfd: '',
                endDate: '',
                studentId: [],
                superActivityId: '',
                activityId: '',
                subActivityId: '',
                remarks: '',
                isEdit: false,  // Important: set to false for new activity
            });
            // Reset tree-related states
            setCheckedActivities([]);
            setCheckedSubActivities([]);
            setSelectedActivityMap({});
        }
        
        setSearchTerm(''); // Clear search when opening dialog
        setOpen(true);
    };
    const onclick = () => {
        setOpen(true);
    }
    const handleClose = () => {
        setOpen(false);
    };
    const handleChange = (event) => {
        setAge(event.target.value);
    };
    const loadMoreData = (event) => {
        setIsFirstLoad(false);
        setStartDate(week.start);
        setEndDate(week.end);
        onSubmit(false)
    };
    const onSubmit = data => {
        const userDetails = JSON.parse(localStorage.getItem("userDetail"));
        const newstartDate = startDate ? startDate : week.start;
        const newendDate = endDate ? endDate : week.end;

        const keys = { "schooleId": userDetails.schooleId, "isFuturePlanning": true, isInitLoad: data ? isFirstLoad : false, "studentId": studentId, 'classId': classId, "startDate": newstartDate, "endDate": newendDate, "status": true, }
        ActivityService.findActivityList(keys).then((res) => {
            excelExport(res);
            // setClassValue("");
            setActivityList(res);
            // setStudentList(res);
        }).catch((err) => {
            // setError(err.message);
        });

    };
    const dateAndTime = (date) => {

        const systemDate = new Date(date);
        const formattedDateTime = systemDate.toLocaleString('en-US', {
            year: 'numeric',
            month: 'long',
            day: 'numeric',
            // hour: 'numeric',
            // minute: 'numeric',
            // second: 'numeric',
            // hour12: true,

        });
        return formattedDateTime;
    }
    // const getActivityList = () => {
    //     const userDetails = JSON.parse(localStorage.getItem("userDetail"));
    //     ActivityTabelService.getAllActivityTabel(userDetails.schooleId).then((res) => {
    //         setAddActivityList(res);
    //     }).catch((err) => {
    //         // setError(err.message);
    //     });
    // }
    const getActivityList = (event, obj) => {
        const userDetails = JSON.parse(localStorage.getItem("userDetail"));
        const getsubActList = {
            schooleId: userDetails.schooleId,
            classId: formik.values.classId,
            superActivityId: event.target.value
        };

        ActivityTabelService.getAllActivityTabeBySuperActivityId(getsubActList).then((res) => {
            
            setAddActivityList(res);
            if (obj) {
                setActivity(obj);
            }
        }).catch((err) => {
            // setError(err.message);
        });
    }
    const excelExport = (res) => {
        // const result = res.map((response) => {

        //     return {
        //         "Student Name": response.studentId ? `${response.studentId.firstName} ${response.studentId.lastName}` : '',
        //         "Class Name": response.classId ? response.classId.className : '',

        //         "Area Of Work": response.superActivityId ? response.superActivityId.superActivityName : '',
        //         "List Of Activities": response.activityId ? response.activityId.activityName : '',
        //         "Exercise": response.subActivityId ? response.subActivityId.subActivityName : '',
        //         "Notes": response.remarks,
        //         "Date": response.sfd,
        //     }

        // })
        const result = [];

        res.forEach((group) => {
            const studentName = group.studentId
                ? `${group.studentId.firstName} ${group.studentId.lastName}`
                : '';
            const className = group.classId?.className || '';

            group.activityRecordsId.forEach((activity) => {
                result.push({
                    "Student Name": studentName,
                    "Class Name": className,
                    "Area Of Work": activity.superActivityId?.superActivityName || '',
                    "List Of Activities": activity.activityId?.activityName || '',
                    "Exercise": activity.subActivityId?.subActivityName || '',
                    "Notes": activity.remarks || '',
                    "Date": activity.sfd || '',
                    "End Date": activity.endDate || '',
                });
            });
        });

        setResult(result);
    };
    const getStudentList = (event, obj) => {
        const userDetails = JSON.parse(localStorage.getItem("userDetail"));
        const getStuList = { classId: event.target.value };



        StudentService.getAllStudentById(userDetails.schooleId, getStuList
        ).then((res) => {

            const studentDetails = res.map(res => {
                return { _id: res._id, studentName: `${res.firstName} ${res.lastName}`, status: true };
            });

            setStudentList(studentDetails);

            if (obj) {
                setActivity(obj);
            }
        }).catch((err) => {
            // setError(err.message);
        });
    }

    const getStudentActivityList = () => {
        const userDetails = JSON.parse(localStorage.getItem("userDetail"));
        ActivityTabelService.getStudentActivity(userDetails.schooleId, true).then((res) => {
            setActivityList(res);
        }).catch((err) => {
            // setError(err.message);
        });
    }
    const getSubActivityList = (event, obj) => {
        const userDetails = JSON.parse(localStorage.getItem("userDetail"));
        const getsubActList = { schooleId: userDetails.schooleId, activityId: event.target.value };
        SubActivityService.getAllSubActivityByActivityId(getsubActList).then((res) => {
            setSubActivityList(res);
            if (obj) {
                setActivity(obj);
            }
        }).catch((err) => {
            // setError(err.message);
        });
    }
    // const getAddClassList = () => {
    //     const userDetails = JSON.parse(localStorage.getItem("userDetail"));
    //     AddClassService.getAllAddClass(userDetails.schooleId).then((res) => {
    //         if (userDetails.role === "TEACHER") {
    //             res = res.filter(res => res._id === userDetails.classId);
    //         }
    //         setAddClassList(res);
    //     }).catch((err) => {
    //         // setError(err.message);
    //     });
    // }
    const getAddClassList = () => {
        const userDetails = JSON.parse(localStorage.getItem("userDetail"));
        AddClassService.getAllAddClass(userDetails.schooleId).then((res) => {
            if (userDetails.role === "TEACHER") {
                res = res.filter(res => res._id === userDetails.classId);
            }
            setAddClassList(res);

            // ✅ Auto-select first class (especially for TEACHER)
            if (userDetails.classId) {
                setClassId(userDetails.classId);
                getStudentList({ target: { value: userDetails.classId } });
            } else {
                setClassId(""); // No default selection
            }
        }).catch((err) => {
            // handle error here if needed
        });
    };

    const getClassNameList = (event) => {
        AddClassService.getAddClassNameById({ className: event.target.value }).then((res) => {
            setClassNameList(res);
        }).catch((err) => {
            setError(err.message);
        });
    }
    const editActivity = (useractivitys, status) => {
        const obj = JSON.parse(JSON.stringify(useractivitys, status));
        obj.classId = useractivitys.classId ? useractivitys.classId._id : '';
        obj.studentId = Array.isArray(useractivitys.studentId)
            ? useractivitys.studentId.map(student => student._id)
            : [useractivitys.studentId]
        // obj.studentId = useractivitys.studentId ? useractivitys.studentId._id : '';
        obj.superActivityId = useractivitys.superActivityId ? useractivitys.superActivityId._id : '';
        obj.activityId = useractivitys.activityId ? useractivitys.activityId._id : '';
        obj.subActivityId = useractivitys.subActivityId ? useractivitys.subActivityId._id : '';
        // getSuperActivityList({ target: { value: obj.classId } }, obj);
        getSuperActivityList({ target: { value: obj.classId } }, obj);
        getStudentList({ target: { value: obj.classId } }, obj);
        getSubActivityList({ target: { value: obj.activityId } }, obj);
        getActivityList({ target: { value: obj.superActivityId } }, obj);
        getAddClassList({ target: { value: obj.superActivityId } }, obj)
        //getStudentActivityList(useractivitys.classId);
        // getAllSuperActivityTabelMultiple(useractivitys.classId);;
        if (status) {
            delete obj._id;
        }
        obj.isEdit = true;
        setActivity(obj);
        
        handleOpen(false)
    }
    const deleteActivity = (activitydelete) => {
        if (activitydelete) {
            ActivityService.deleteActivity(activitydelete).then((res) => {

                onSubmit()
            }).catch((err) => {
            });
        }
    };
    // State for selected activities and subActivities
    const [checkedActivities, setCheckedActivities] = useState([]);
    const [checkedSubActivities, setCheckedSubActivities] = useState([]);
    const [searchTerm, setSearchTerm] = useState("");
    const [selectedActivityMap, setSelectedActivityMap] = useState({});  // Store relationships between sub-activities and their parents

    // Create refs for form fields
    const formRefs = {
        sfd: React.useRef(),
        endDate: React.useRef(),
        classId: React.useRef(),
        studentId: React.useRef(),
        remarks: React.useRef()
    };

    // Function to scroll to error
    const scrollToError = (errors) => {
        const firstError = Object.keys(errors)[0];
        if (firstError && formRefs[firstError]?.current) {
            formRefs[firstError].current.scrollIntoView({
                behavior: 'smooth',
                block: 'center'
            });
        }
    };

    const formik = useFormik({
        initialValues: activity,
        enableReinitialize: true,
        validationSchema: validationSchema,
        validateOnChange: true,
        validateOnBlur: true,
        onSubmit: (values, { resetForm }) => {
            const userDetails = JSON.parse(localStorage.getItem("userDetail"));
            values.schooleId = userDetails.schooleId;
            values.authorizedPerson = userDetails.email
            values.isFuturePlanning = true;
            values.key = "Future Plane"
            // Attach checked activities/subActivities and their relationships to form values
            values.selectedActivities = checkedActivities;
            values.selectedSubActivities = checkedSubActivities;
            values.activityRelationships = selectedActivityMap;
            
            if (activity._id) {
                ActivityService.upadeActivity(values).then((res) => {
                    handleClose();
                    onSubmit()
                    resetForm()
                    alert("Activity Updated Successfully.");
                }).catch((err) => {
                });
            } else {
                let currentYear = new Date().getFullYear();
                let nextYear = new Date().getFullYear() + 1;
                values['academicYear'] = currentYear + "-" + nextYear;
                if (values.sfd) {
                    values['sfd'] = new Date(values['sfd']).toISOString().split("T")[0];
                }
                ActivityService.creteMultipleActivity(values).then((res) => {
                    onSubmit()
                    resetForm();
                    handleClose();
                    alert(" Activity Added Successfully.");
                })
                .catch((err) => {
                    alert(err.response.data.message)
                })
            }
        },
    });
    // const renderTree = (nodes) => (
    //     <TreeItem
    //         key={nodes._id}
    //         nodeId={nodes._id}
    //         label={
    //             nodes.type === "subActivity" ? (
    //                 <div style={{ display: "flex", alignItems: "center" }}>
    //                     <Checkbox
    //                         size="small"
    //                         color="primary"
    //                         onChange={() => {
    //                             formik.setFieldValue("subActivityId", nodes._id);
    //                             formik.setFieldValue("activityId", nodes.activityId || "");
    //                             formik.setFieldValue("superActivityId", nodes.superActivityId || "");
    //                         }}
    //                     />
    //                     {nodes.name}
    //                 </div>
    //             ) : (
    //                 nodes.name
    //             )
    //         }
    //     >
    //         {Array.isArray(nodes.children)
    //             ? nodes.children.map((child) => renderTree(child))
    //             : null}
    //     </TreeItem>
    // );
    // Filter function for activities and sub-activities
    const filterTreeNode = (node) => {
        if (searchTerm === "") return true;
        const term = searchTerm.toLowerCase();

        // Check if current node matches
        if (node.superActivityName?.toLowerCase().includes(term) ||
            node.activityName?.toLowerCase().includes(term) ||
            node.subActivityName?.toLowerCase().includes(term)) {
            return true;
        }

        // Check children (activities)
        if (node.activities?.some(activity => 
            activity.activityName?.toLowerCase().includes(term) ||
            activity.subActivities?.some(sub => 
                sub.subActivityName?.toLowerCase().includes(term)
            )
        )) {
            return true;
        }

        // Check sub-activities
        if (node.subActivities?.some(sub => 
            sub.subActivityName?.toLowerCase().includes(term)
        )) {
            return true;
        }

        return false;
    };

    const renderTree = (node) => {
        // Don't render if it doesn't match the search
        if (!filterTreeNode(node)) return null;
         const superActivitId = node._id;
        // Super Activity node
        if (node.superActivityName) {
            return (
                <TreeItem
                    key={node._id}
                    nodeId={node._id}
                   // label={node.superActivityName}
                    label={
                    <div style={{ display: "flex", alignItems: "center" }}>
                    <LanguageIcon style={{ marginRight: 8, color: "#4caf50" }} />
                    {node.superActivityName}
                    </div>
                }
                    onClick={(e) => e.stopPropagation()}
                >
                    {Array.isArray(node.activities) && node.activities.map(renderTree)}
                </TreeItem>
            );
        }
        // Activity node
        if (node.activityName) {
            const hasSubActivities = Array.isArray(node.subActivities) && node.subActivities.length > 0;
            const subActivityIds = hasSubActivities ? node.subActivities.map(sub => sub._id) : [];
            
            return (
                <TreeItem
                    key={node._id}
                    nodeId={node._id}
                    label={
                        <div 
                            style={{ display: "flex", alignItems: "center" }}
                            onClick={(e) => e.stopPropagation()}
                        >
                            <Checkbox
                                size="small"
                                color="primary"
                                checked={checkedActivities.includes(node._id)}
                                onChange={(e) => {
                                    e.stopPropagation();
                                    const checked = e.target.checked;
                                    if (checked) {
                                        setCheckedActivities(prev => [...prev, node._id]);
                                        // If there are no subActivities, treat the activity itself as a selectable item
                                        if (!hasSubActivities) {
                                            setSelectedActivityMap(prev => ({
                                                ...prev,
                                                [node._id]: {
                                                    activityId: node._id,
                                                    superActivityId: node.superActivityId,
                                                    isChild: false 
                                                    // No subActivityId since this is the activity itself
                                                }
                                            }));
                                        }
                                    } else {
                                        setCheckedActivities(prev => prev.filter(id => id !== node._id));
                                        if (!hasSubActivities) {
                                            setSelectedActivityMap(prev => {
                                                const newMap = { ...prev };
                                                delete newMap[node._id];
                                                return newMap;
                                            });
                                        }
                                    }
                                }}
                            />
                            <span onClick={(e) => e.stopPropagation()}>{node.activityName}</span>
                        </div>
                    }
                >
                    {hasSubActivities && node.subActivities.map(sub =>
                        renderTree({ ...sub, parentActivityId: node._id, superActivityId: node.superActivityId,isChild: true })
                    )}
                </TreeItem>
            );
        }
        // SubActivity node
        if (node.subActivityName) {
            return (
                <TreeItem
                    key={node._id}
                    nodeId={node._id}
                    label={
                        <div 
                            style={{ display: "flex", alignItems: "center" }}
                            onClick={(e) => e.stopPropagation()}
                        >
                            <Checkbox
                                size="small"
                                color="primary"
                                checked={checkedSubActivities.includes(node._id)}
                                onChange={(e) => {
                                    e.stopPropagation();
                                    const checked = e.target.checked;
                                    if (checked) {
                                        // Check sub-activity
                                        setCheckedSubActivities(prev => [...prev, node._id]);
                                        // Check parent activity if not already checked
                                        if (!checkedActivities.includes(node.parentActivityId)) {
                                            setCheckedActivities(prev => [...prev, node.parentActivityId]);
                                        }
                                        // Store the relationship
                                        setSelectedActivityMap(prev => ({
                                            ...prev,
                                            [node._id]: {
                                                subActivityId: node._id,
                                                activityId: node.parentActivityId,
                                                superActivityId: node.superActivityId,
                                                isChild: true
                                            }
                                        }));
                                    } else {
                                        // Just uncheck the sub-activity
                                        setCheckedSubActivities(prev => prev.filter(id => id !== node._id));
                                        // Remove the relationship
                                        setSelectedActivityMap(prev => {
                                            const newMap = { ...prev };
                                            delete newMap[node._id];
                                            return newMap;
                                        });
                                    }
                                }}
                            />
                            <span onClick={(e) => e.stopPropagation()}>{node.subActivityName}</span>
                        </div>
                    }
                />
            );
        }
        return null;
    };

    return (

        <>
            <PageTitle title=" Weekly Plan" button={<Button
                variant="contained" onClick={() => handleOpen(true)}
                size="medium"
                color="secondary" style={{ backgroundColor: 'rgb(15 59 98)' }}> Add Activity
            </Button>} />
            <Card sx={{ maxWidth: 500 }}>
                <Box style={{ margin: 15 }}  >

                    <Grid container spacing={2} columns={12}  >
                        <Grid item xs={6} sm={6} md={2} >
                            <FormControl className={classes.formControl} style={{ width: 170 }}
                            >
                                <InputLabel id="demo-simple-select-label">Select Class</InputLabel>
                                <Select
                                    labelId="demo-simple-select-label"
                                    id="demo-simple-select"
                                    name="classId"
                                    label="selectClass"
                                    // onChange={e => {  getStudentList(e) }}
                                    onChange={e => { setClassId(e.target.value); getStudentList(e) }}
                                    value={classId}
                                >
                                    <MenuItem value="">
                                        <em>None</em>
                                    </MenuItem>

                                    {addClassList.map(({ _id, className }) => (
                                        <MenuItem key={_id} value={_id}>{className}

                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        </Grid>
                        <Grid item xs={6} sm={6} md={2} >
                            <FormControl variant="standard" fullWidth>
                                <InputLabel id="studentName">Student Name</InputLabel>
                                <Select
                                    labelId="studentName"
                                    id="studentName"
                                    label="Student Name"
                                    name="studentId"

                                    value={studentId}
                                    onChange={e => { setStudentId(e.target.value) }}
                                // error={formik.touched.studentId && Boolean(formik.errors.studentId)}
                                // helperText={formik.touched.studentId && formik.errors.studentId}
                                >
                                    <MenuItem value="">
                                        <em>None</em>
                                    </MenuItem>
                                    {studentList.map(({ index, _id, studentName }) => (
                                        <MenuItem key={index} value={_id}>{studentName}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        </Grid>
                        <Grid item xs={6} sm={6} md={2}>
                            <form className={classes.container} noValidate>
                                <SchoolDatePicker
                                    id="dob"
                                    name="dob"
                                    label="Start Date"
                                    value={startDate}
                                    onChange={(iso) => setStartDate(iso)}
                                />
                            </form>
                        </Grid>
                        <Grid item xs={6} sm={6} md={2} >
                            <SchoolDatePicker
                                id="dob"
                                name="dob"
                                label="End Date"
                                value={endDate}
                                onChange={(iso) => setEndDate(iso)}
                            />
                        </Grid>
                        <Grid item xs={6} sm={6} md={2} >
                            <Button style={{ backgroundColor: 'rgb(15 59 98)', color: 'white' }}
                                type="button"

                                onClick={() => onSubmit()} variant="contained"
                            >

                                Search</Button>
                        </Grid>
                        <Grid item xs={6} sm={6} md={2}   >

                            <ExportExcel excelData={result} fileName={'Student Activity'} />


                        </Grid>
                    </Grid>

                </Box>
            </Card>
            <br></br>
            <Grid container spacing={4}>
                <Grid item xs={12}>

                    <Widget title="" upperTitle noBodyPadding bodyClass={classes.tableOverflow}>
                        {isFirstLoad ? (
                            <div style={{ textAlign: "right", margin: "10px" }}>
                                <Button style={{ backgroundColor: 'rgb(15 59 98)', color: 'white' }}
                                    type="button"
                                    startIcon={<RefreshIcon />}

                                    onClick={() => {
                                        loadMoreData();
                                    }}
                                >  Load More Plans
                                </Button>


                            </div>
                        ) : ""}


                        <Table className="mb-0">
                            <TableHead >
                                <TableRow>
                                    {tableHeaders.map(key => (
                                        <StyledTableCell key={key}>{key}</StyledTableCell>
                                    ))}
                                </TableRow>
                            </TableHead>

                            <TableBody>
                                {activityList
                                    .slice(pg * rpg, pg * rpg + rpg)
                                    .map((group) => (
                                        group.activityRecordsId.length > 0 && (
                                            <React.Fragment key={group.studentId?._id}>
                                                <TableRow>
                                                    <TableCell
                                                        className="pl-3 fw-bold"
                                                        colSpan={tableHeaders.length}
                                                        style={{
                                                            backgroundColor: '#7f8582',
                                                            color: '#ffff',
                                                            fontSize: '17px',
                                                            fontWeight: '500'
                                                        }}
                                                    >
                                                        {group.studentId?.firstName} {group.studentId?.lastName}
                                                    </TableCell>
                                                </TableRow>

                                                {group.activityRecordsId.map((activity) => (
                                                    <TableRow key={activity._id}>
                                                        <TableCell className="pl-3 fw-normal">
                                                            {activity.classId?.className || ''}
                                                        </TableCell>
                                                        <TableCell className="pl-3 fw-normal">
                                                            {activity.superActivityId?.superActivityName || ''}
                                                        </TableCell>
                                                        <TableCell className="pl-3 fw-normal">
                                                            {activity.activityId?.activityName || ''}
                                                        </TableCell>
                                                        <TableCell className="pl-3 fw-normal">
                                                            {activity.subActivityId?.subActivityName || ''}
                                                        </TableCell>
                                                        {/* <TableCell className="pl-3 fw-normal">
                {activity.authorizedPerson}
              </TableCell> */}
                                                        <TableCell className="pl-3 fw-normal">{activity.remarks}</TableCell>
                                                        {/* <TableCell className="pl-3 fw-normal">{activity.key}</TableCell> */}
                                                        {/* <TableCell>{dateAndTime(event.createdAt)}</TableCell> */}

                                                        <TableCell className="pl-3 fw-normal">{activity.sfd}</TableCell>

                                                        <TableCell className="pl-3 fw-normal">{activity.endDate}</TableCell>
                                                        <TableCell>
                                                            <EditIcon style={{ cursor: "pointer" }} onClick={() => editActivity(activity, false)} />
                                                        </TableCell>
                                                        <TableCell>
                                                            <DeleteIcon style={{ cursor: "pointer" }} onClick={() => deleteActivity(activity._id)} />
                                                        </TableCell>
                                                        <TableCell>
                                                            <AddIcon style={{ cursor: "pointer" }} onClick={() => editActivity(activity, true)} />
                                                        </TableCell>
                                                    </TableRow>
                                                ))}
                                            </React.Fragment>
                                        )
                                    ))}
                            </TableBody>



                        </Table>
                        <TablePagination
                            component="div"
                            rowsPerPageOptions={[1000, 10000, 1000000]}
                            count={activityList.length}
                            page={pg}
                            onPageChange={handleChangePage}
                            rowsPerPage={rpg}
                            onRowsPerPageChange={handleChangeRowsPerPage}
                        />
                    </Widget>
                </Grid>
            </Grid>
            <Dialog open={open} onClose={handleClose} PaperProps={{
                style: {
                    width: '460px', // set custom width
                    maxWidth: '80%', // optional, responsive behavior
                },
            }}>
                <DialogTitle>Add Activity</DialogTitle>
                <form onSubmit={formik.handleSubmit} >
                    <DialogContent style={{ width: 508 }}>
                        <SchoolDatePicker
                            id="sfd"
                            name="sfd"
                            label="Start Date"
                            error={formik.touched.sfd && Boolean(formik.errors.sfd)}
                            value={formik.values.sfd}
                            onChange={(iso) => formik.setFieldValue("sfd", iso)}
                            helperText={formik.touched.sfd && formik.errors.sfd}
                        />
                        <SchoolDatePicker
                            id="endDate"
                            name="endDate"
                            label="End Date"
                            value={formik.values.endDate}
                            onChange={(iso) => formik.setFieldValue("endDate", iso)}
                            error={formik.touched.endDate && Boolean(formik.errors.endDate)}
                            helperText={formik.touched.endDate && formik.errors.endDate}
                        />
                        <FormControl className={classes.formControl} style={{ width: 423 }}
                        >
                            <InputLabel id="demo-simple-select-label">Select Class</InputLabel>
                            <Select
                                labelId="demo-simple-select-label"
                                id="demo-simple-select"
                                name="classId"
                                label="selectClass"
                                value={formik.values.classId}
                                // value={classId}
                                onChange={e => { formik.handleChange(e); getStudentList(e); getAllSuperActivityTabelMultiple(e) }}
                                // onChange={formik.handleChange}

                                error={formik.touched.classId && Boolean(formik.errors.classId)}
                                helperText={formik.touched.classId && formik.errors.classId}
                            >
                                <MenuItem value="">
                                    <em>None</em>
                                </MenuItem>

                                {addClassList.map(({ _id, className }) => (
                                    <MenuItem key={_id} value={_id}>{className}

                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                        <FormControl variant="standard" style={{ width: 423 }}>
                            <InputLabel id="studentName-label">Student Name</InputLabel>
                            <Select
                                labelId="studentName-label"
                                id="studentName-select"
                                label="Student Name"
                                name="studentId"
                                disabled={formik.values.isEdit}
                                multiple
                                value={formik.values.studentId} // make sure this is an array in Formik's initialValues
                                onChange={formik.handleChange}
                                // Customize how the selected values are displayed in the input
                                renderValue={(selected) => {
                                    // Find student names for the selected IDs
                                    const selectedNames = studentList
                                        .filter(({ _id }) => selected.includes(_id))
                                        .map(({ studentName }) => studentName);
                                    return selectedNames.join(", ");
                                }}
                            >
                                {studentList.map(({ _id, studentName }) => (
                                    <MenuItem key={_id} value={_id}>
                                        {studentName}
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                        <div>

                            {formik.values.isEventForAllStudent}
                            <Grid item xs={12} sm={12} md={12}>
                                <FormControlLabel
                                    control={
                                        <Checkbox name="isEventForAllStudent" id="terms"
                                            value={formik.values.isEventForAllStudent}
                                            checked={formik.values.isEventForAllStudent}
                                            onChange={formik.handleChange}
                                            error={formik.touched.isEventForAllStudent && Boolean(formik.errors.isEventForAllStudent)}
                                            helperText={formik.touched.isEventForAllStudent && formik.errors.isEventForAllStudent}
                                        />
                                    }
                                    label="For All Class Students"
                                />
                            </Grid>


                        </div>
                        {formik.values.isEdit ? (
                            // Show three-level select boxes when editing
                            <>
                                <FormControl variant="standard" style={{ width: 423 }}>
                                    <InputLabel id="demo-simple-select-standard-label">Area Of Work</InputLabel>
                                    <Select
                                        labelId="demo-simple-select-standard-label"
                                        id="superActivityName"
                                        label="Area Of Work "
                                        name="superActivityId"
                                        onChange={e => { formik.handleChange(e); getActivityList(e) }}
                                        value={formik.values.superActivityId}
                                        error={formik.touched.superActivityId && Boolean(formik.errors.superActivityId)}
                                        helperText={formik.touched.superActivityId && formik.errors.superActivityId}
                                    >
                                        <MenuItem value="">
                                            <em>None</em>
                                        </MenuItem>
                                        {addSuperActivityList.map(({ _id, superActivityName }) => (
                                            <MenuItem key={_id} value={_id}>{superActivityName}</MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                                <FormControl variant="standard" style={{ width: 423 }}>
                                    <InputLabel id="demo-simple-select-standard-label">List Of Activities</InputLabel>
                                    <Select
                                        labelId="demo-simple-select-standard-label"
                                        id="activityName"
                                        label="List Of Activities"
                                        name="activityId"
                                        onChange={e => { formik.handleChange(e); getSubActivityList(e) }}
                                        value={formik.values.activityId}
                                        error={formik.touched.activityId && Boolean(formik.errors.activityId)}
                                        helperText={formik.touched.activityId && formik.errors.activityId}
                                    >
                                        <MenuItem value="">
                                            <em>None</em>
                                        </MenuItem>
                                        {addActivityList.map(({ _id, activityName }) => (
                                            <MenuItem key={_id} value={_id}>{activityName}</MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                                <FormControl variant="standard" style={{ width: 423 }}>
                                    <InputLabel id="subActivityName">Exercise</InputLabel>
                                    <Select
                                        labelId="subActivityName"
                                        id="subActivityId"
                                        label="Exercise"
                                        name="subActivityId"
                                        value={formik.values.subActivityId}
                                        onChange={formik.handleChange}
                                        error={formik.touched.subActivityId && Boolean(formik.errors.subActivityId)}
                                        helperText={formik.touched.subActivityId && formik.errors.subActivityId}
                                    >
                                        <MenuItem value="">
                                            <em>None</em>
                                        </MenuItem>
                                        {subActivityList.map(({ _id, subActivityName }) => (
                                            <MenuItem key={_id} value={_id}>{subActivityName}</MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                            </>
                        ) : (
                            // Show tree structure when adding new
                            <>
                                <TextField
                                    fullWidth
                                    margin="dense"
                                    id="search-activities"
                                    label="Search Activities"
                                    type="text"
                                    variant="outlined"
                                    value={searchTerm}
                                    onChange={(e) => setSearchTerm(e.target.value)}
                                    style={{ marginBottom: '20px' }}
                                    InputProps={{
                                        startAdornment: (
                                            <span style={{ marginRight: '8px' }}>🔍</span>
                                        ),
                                        style: { width: 423 }
                                    }}
                                />
                                <TreeView
                                    defaultCollapseIcon={<ExpandMoreIcon />}
                                    defaultExpandIcon={<ChevronRightIcon />}
                                >
                                    {selectedActivities.map((node) => renderTree(node))}
                                </TreeView>
                            </>
                        )}


                        <TextField InputProps={{ style: { width: 423 } }}
                            margin="dense"
                            id="remarks"
                            name="remarks"
                            label="Notes"
                            type="text"
                            variant="standard"
                            value={formik.values.remarks}
                            onChange={formik.handleChange}
                            error={formik.touched.remarks && Boolean(formik.errors.remarks)}
                            helperText={formik.touched.remarks && formik.errors.remarks}
                        />
                    </DialogContent>
                    <DialogActions style={{
                        justifyContent: "flex-end", // Aligns buttons to right
                        paddingRight: "16px",       // Adds spacing from right edge
                        gap: "8px"
                    }} >
                        <Button onClick={handleClose} >Cancel</Button>
                        <Button type="submit" onClick={verifyeetnt} >Add</Button>
                    </DialogActions>
                </form>
            </Dialog>

        </>
    );
}



